import { Body, Heading } from 'components/text';
import { FC } from 'react';
import Image from 'next/image';
import AboutMylerCover from 'blocks/MylerSection/assets/myler-about-cover.jpeg';
import ArrowBullet from '../icons/ArrowBulletIcon';
import Button from 'components/Button/Button';
import { MylerTools } from '../contants';
import { useMediaQuery } from '@mui/material';
import Container from 'components/container';

type IWhy = {
  handleOpenEnquiryForm: () => void;
};
const Why: FC<IWhy> = ({ handleOpenEnquiryForm }) => {
  const isMobile = useMediaQuery(`(max-width:700px)`);

  return (
    <Container className="why-myler-section" as="section">
      <div className="why-myler-section__title" id="why-myler">
        <Heading as="h4">Why MyLER?</Heading>
      </div>
      <div className="why-myler-section__subtitle">
        <Heading as="h5">At the heart of MyLER lie three core pillars:</Heading>
      </div>
      <div className="myler-tools">
        <div className="myler-tools__container">
          {MylerTools.map((tool, index) => {
            return (
              <div key={index} className="myler-tools__tool">
                <div className="myler-tools__tool-title">
                  <ArrowBullet isMobile={isMobile} />
                  <Heading as="h5"> {tool.name}</Heading>
                </div>
                <div className="myler-tools__tool-description">
                  <Body color="grey-dark">{tool.description}</Body>
                </div>
              </div>
            );
          })}

          <div className="why-myler-section__enquire">
            <Button
              title={'Enquire'}
              className="why-myler-section__enquire-button"
              onClick={() => handleOpenEnquiryForm()}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Why;
